import { ResponseProjectDetail } from "@models/data-contracts";

import ProjectMemberViewModel from "./ProjectMemberViewModel";

class ProjectViewModel {
  id: number;
  title: string;
  description: string;
  thumbnailImageUrl: string;
  contentImageUrlList: { fileId: number; url: string }[];
  displayFee: string;
  fee: number;
  hasPaid: boolean;
  isFull: boolean;
  isClosed: boolean;

  memberCount: number;
  maxMemberCount: number;
  memberList?: ProjectMemberViewModel[];

  static create(responseData: ResponseProjectDetail) {
    const project = new ProjectViewModel();

    project.id = responseData.id;
    project.title = responseData?.title;
    project.description = responseData.description;

    project.thumbnailImageUrl = responseData.fileList?.[0]?.url;
    project.contentImageUrlList = responseData.contentFileList.map(
      ({ url, id }) => ({
        fileId: id,
        url,
      }),
    );

    project.displayFee =
      responseData.fee === 0
        ? "FREE"
        : `${responseData?.fee.toLocaleString()} KRW`;

    project.fee = responseData.fee;

    project.hasPaid = responseData.payYn === "Y";

    project.isFull = responseData?.memberList.length >= responseData.maxPeople;
    project.isClosed = responseData?.isClosed === "Y";
    project.memberCount = responseData?.memberList.length;
    project.maxMemberCount = responseData.maxPeople;
    project.memberList = responseData.memberList.map((member) =>
      ProjectMemberViewModel.create(member),
    );

    return project;
  }
}

export default ProjectViewModel;
